module.exports = __webpack_public_path__ + "img/logout.4234f52a.svg";